import { SOFTPHONES_KEY, VALIDATING_TELEPHONY, SM_QUEUE_SERVER } from '../constants/constants.js';
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from '../constants/Notifications.js';
import { messageFirstCall, triggerNotifications } from '../Helpers/helperMessages.js';
import { Logger } from '../logging/Logger.js';


export const SOFTPHONE_CALLBACKS = {
	[SOFTPHONES_KEY.WEBRTC]: that => {
		Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] SIP method');
		let _that = that;
		that.agentController.AgentObject.onSipAccepted = () => {
			if (!_that.sharedData.getLogged()) {
				_that.svrEvents.onValidatingTelephony({
					telephonyState:VALIDATING_TELEPHONY.VALIDATING,
					status:1,
				});
				setTimeout(() => {
					if(!_that.sharedData.getLogged()){
						_that.svrEvents.onValidatingTelephony({
							telephonyState:VALIDATING_TELEPHONY.ERROR,
							status:3,}
						);
					}
				}, parseInt(_that.telephonyTime)*1000);
				_that.sendToRabbit(SM_QUEUE_SERVER, messageFirstCall(_that.sharedData.getUserData().Login, _that.sharedData.getParameters().UserID));
				let sipID = 'sip:' + _that.sharedData.getParameters().Extension + '|' + _that.sharedData.getParameters().UserID + '|0';
				setTimeout(() => {
					_that.makeCall(sipID);
				}, 500);
			}
		};
		that.agentController.AgentObject.onSipRejected = () => {
			Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] SIP Rejected');
		};
		that.agentController.AgentObject.onCallEntry = () => {
			Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Incoming Call');
		};
		that.agentController.AgentObject.uiCallTerminated = () => {
			Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Call Finished');
		};
		that.agentController.AgentObject.onCallAnswered = () => {
			Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Call Answered');
		};
		that.agentController.AgentObject.onCallRejected = () => {
			Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Call Rejected');
		};
		that.agentController.AgentObject.onTransportDisconnected = function (parameter) {
			Logger.Debug('TRANSPORT DISCONNECTED REASON:', parameter);
			if(parameter.attempt > 0){
				const transporMessage = {
					statusCode: 1006, 
					message: MESSAGE_CODE.CONNECTION_ALERTS[1006] + parameter.attempt + '/50',
					type: 'Error',
					currentAttempt: parameter.attempt,
					maxAttempt: 50
				};
				that.errorEvents.onConnectionBackgroundAttempt(transporMessage);
				triggerNotifications(that, MESSAGE_CODE.CONNECTION_ALERTS[1006], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
			}
			if (that.rabbitConnected) {
				if (parameter.attempt < 50) {
						const objMessage = {
							statusCode: 8001, 
							message: MESSAGE_CODE.CONNECTION_ALERTS[8001] + (parameter.attempt + 1),
							type: 'Error',
							currentAttempt: parameter.attempt,
							maxAttempt: 4
						};
						that.errorEvents.onConnectionAttempt(objMessage);
						triggerNotifications(that, MESSAGE_CODE.CONNECTION_ALERTS[8001], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
				} else {
					const objMessage = {
						statusCode: 1, 
						message: MESSAGE_CODE.CONNECTION_ALERTS[1],
						type: 'Error',
						developerHint: 'Execute method [ logout ] to start again.'
					};
					that.errorEvents.onConnectionLost(objMessage);
					triggerNotifications(that, MESSAGE_CODE.CONNECTION_ALERTS[1], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
				}
			}
		};
		that.agentController.AgentObject.onTransportConnected = function () {
			if (that.rabbitConnected) {
				Logger.Debug('TRANSPORT CONNECTED');
			}
		};
		that.agentController.AgentObject.onDataStreamInfo = (streamLevel, message) => {
			if (streamLevel > 1) {
				Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS][Stream_Information]', message);
			}
		};

		that.agentController.AgentObject.onChangeDeviceList = audioList => {
			Logger.Debug('onChangeDeviceList', audioList);
			for (let i in audioList) {
				let device = audioList[i];
				let [direction] = device.kind.match(/(\w+)(input|output)/i);
				if (direction === 'audio') {
					Logger.Debug('onChangeDeviceList', { label: device.label, direction: direction });
				}
			}
		};

		that.agentController.AgentObject.onGetStreamMicFail = () => {
			Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] onGetStreamMicFail');
			const response ={
				error: 'Enable Microphone',
			}
			_that.errorEvents.onErrorMicro(response);
		};
	},
};

export const SOFTPHONE_VALIDATING = {
	[SOFTPHONES_KEY.WEBRTC]: () => {
		Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_VALIDATING] SIP method');
	},
};

export const SOFTPHONE_MAKECALL = {
	[SOFTPHONES_KEY.WEBRTC]: (that, message, userID) => {
		that.parametersEngine();
		that.setIpEngine(message.EngineId, that.Engines[message.EngineId]);
		let sipID = 'sip:' + that.sharedData.getParameters().Extension + '|' + userID + '|' + message.CallId;
		let _that = that;
		setTimeout(() => {
			_that.makeCall(sipID);
		}, 200);
	},
};

export const SOFTPHONE_PARAMETERS = {
	[SOFTPHONES_KEY.WEBRTC]: that => {
		let SipParameters = that.sharedData.getGeneralPermissions()[183];
		let settingSIP = SipParameters.split('|');
		let setting143 = that.sharedData.getGeneralPermissions()[143];
		if(!setting143){
			Logger.Warn('[STRATEGIES_SOFTPHONE][WEB_RTC] Not Config: ', setting143);
		}
		let ipKamailio = setting143.split('|');
		ipKamailio = ipKamailio[1].split(',');
		let stunServers = settingSIP[6].replace(/\\/g, '');
		try {
			stunServers = JSON.parse(stunServers);
		} catch (e) {
			Logger.Warn('[STRATEGIES_SOFTPHONE][WEB_RTC] invalid stun server', e);
		}
		that.agentController.AgentObject.SIP_wsServers = [settingSIP[1]];
		that.agentController.AgentObject.SIP_authorizationUser = settingSIP[2].replaceAll('#UserIP#', that.sharedData.getIPfromAPI());
		that.agentController.AgentObject.SIP_uri = settingSIP[3].replaceAll('#UserIP#', that.sharedData.getIPfromAPI());
		that.agentController.AgentObject.SIP_password = settingSIP[4];
		that.agentController.AgentObject.SIP_userAgentString = 'Nuxiba-WebRTC';
		that.agentController.AgentObject.SIP_stunServers = stunServers;
		that.agentController.AgentObject.SIP_register = false;
		that.agentController.AgentObject.SIP_iceCheckingTimeout = 750;
		that.agentController.setUserId(Logger.getUserID()); 
		that.setIpEngine(0, ipKamailio[0]);
	},
};

